import { compose, withHandlers, lifecycle } from 'recompose';

export const withEscHandler = compose(
  withHandlers({
    handleKeyUp: ({ handleCancelClick, onClose, onCancel }) => event => {
      const handleCancel = handleCancelClick || onClose || onCancel;
      if (event.keyCode === 27) {
        event.preventDefault();
        handleCancel();
      }
    },
  }),

  lifecycle({
    componentDidMount() {
      window.addEventListener('keyup', this.props.handleKeyUp, false);
    },

    componentWillUnmount() {
      window.removeEventListener('keyup', this.props.handleKeyUp, false);
    },
  }),
);
